import React, { useEffect, useState } from "react";
import camelCase from "lodash/camelCase";
import startCase from "lodash/startCase";
import { useRouter } from "next/router";

import { getDeliveryCopyBlock } from "api/requests/directus/getDeliveryCopyBlock";
import { DeliveryCopyBlock as DeliveryCopyBlockType } from "custom-types/Directus";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import isCanada from "utils/isCanada";
import parseNextRouterAsPath from "utils/parseNextRouterAsPath";

import DeliveryCopyBlock from "components/DeliveryGateway/DeliveryCopyBlock/";

type Props = {
  collection: string;
  className?: string;
};

const DeliveryCopyBlockWrapper = ({ collection, className }: Props) => {
  const { asPath } = useRouter();
  const { path: slug } = parseNextRouterAsPath(asPath);

  const [copyBlocks, setCopyBlocks] = useState<DeliveryCopyBlockType>();
  const countryCode = useDomainCountryCode();
  const age = isCanada(countryCode) ? 18 : 21;
  useEffect(() => {
    getDeliveryCopyBlock(collection, slug, countryCode).then((data) => {
      if (data) {
        setCopyBlocks(data);
      }
    });
  }, []);
  const cityStateArray = slug
    .split("/")
    .filter((item) => item !== "")
    .map((word) => startCase(camelCase(word)));
  let header;
  let copy;

  if (cityStateArray.length === 1) {
    header = "Same-day weed delivery is now available on Leafly!";
    copy = `To start your order, simply enter your address to shop local menus from
    the most reputable and reliable weed delivery services near you. Order
    your favorite THC products for quick delivery including cannabis flower,
    edibles, dabs, pre-rolls, vape pens, cartridges, and accessories.
    Remember, only an adult aged ${age} years old or older can place an order
    for recreational weed delivery, and medical marijuana patients must have
    a valid medical card to place a medical cannabis delivery order.`;
  }
  if (cityStateArray.length === 2) {
    header = `Same-day weed delivery in ${cityStateArray[1]} is now available on Leafly!`;
    copy = `Simply enter your address to shop local menus across ${cityStateArray[1]}
    from the most reputable and reliable weed delivery services. Order your
    favorite THC products for delivery including cannabis flower, edibles, dabs,
    pre-rolls, vape pens, cartridges, and accessories. Remember, only an adult
    aged ${age} years old or older can place an order for weed delivery in ${cityStateArray[1]},
    and medical marijuana patients must have a valid medical card to place a
    medical cannabis delivery order.`;
  }
  if (cityStateArray.length === 3) {
    header = `Same-day weed delivery in ${cityStateArray[2]}, ${cityStateArray[1]} is now available on Leafly!`;
    copy = `Simply enter your address to shop local menus in ${cityStateArray[2]} from the most
      reputable and reliable weed delivery services. Order your favorite THC products for
      delivery including cannabis flower, edibles, dabs, pre-rolls, vape pens, cartridges, and
      accessories. Remember, only an adult aged ${age} years old or older can place
      an order for weed delivery in ${cityStateArray[2]}, and medical marijuana patients must have
      a valid medical card to place a medical cannabis delivery order.`;
  }

  return copyBlocks?.copy_block?.length ? (
    <DeliveryCopyBlock data={copyBlocks} className={className} />
  ) : (
    <div className="container my-lg">
      <h2 className="font-bold my-sm">{header}</h2>
      <p className="my-sm">{copy}</p>
    </div>
  );
};

export default DeliveryCopyBlockWrapper;
